var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatform({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_741_31870",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 12,
    height: 12,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 12,
    height: 12,
    rx: 1,
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_741_31870)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_741_31870",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 12,
    height: 12,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 12,
    height: 12,
    rx: 1,
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-2_741_31870)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_741_31870",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3,
    width: 12,
    height: 12,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3,
    width: 12,
    height: 12,
    rx: 1,
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-3_741_31870)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_741_31870",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 12,
    height: 12,
    rx: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 12,
    height: 12,
    rx: 1,
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-4_741_31870)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.52934e66f435a570fc14ff62290cc8b5.svg";
export { ForwardRef as ReactComponent };